import { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { highlight } from 'utils/func';

function DiffColumn({ isDifferent, content = [] }) {
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useLayoutEffect(() => {
    if (ref?.current?.clientHeight) {
      setHeight(ref.current.clientHeight);
    }
  });

  return (
    <td
      ref={ref}
      className={`relative ${highlight(isDifferent)} ${!content ? 'not-show' : ''} text-center`}
    >
      {isDifferent && content?.length > 0 && (
        <>
          <i
            className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
            data-pr-position="left"
            style={{ fontSize: '1.4rem', cursor: 'pointer' }}
          />
          <span
            className="hidden absolute bg-white p-2 shadow-4"
            style={{
              bottom: height + 5,
              right: 15,
              width: 500,
              maxHeight: 600,
              zIndex: 100,
              overflowY: 'auto',
            }}
          >
            {content}
          </span>
        </>
      )}
    </td>
  );
}

export default DiffColumn;

DiffColumn.propTypes = {
  isDifferent: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.array,
};

DiffColumn.defaultProps = {
  isDifferent: false,
  content: [],
};
